export class apiList {
  login: string = '/admin/login';
  logout: string = '/admin/logout';
  profile: string = '/admin/getProfile';
}
